import { useQuery } from "react-query";
import { makeStyles } from "helpers/StyleHelper";
import { useTheme } from "@mui/material/styles";

import { ResponseOfOrganizationDetails } from "services/KnowfullyAdminClient";
import useGlobalContext from "hooks/globalData";
import {
  Box,
  TextField,
  TextFieldProps,
  Theme,
  Tooltip,
  Typography,
} from "@mui/material";

const useStyles = makeStyles((theme: Theme) => ({
  organizationLabel: {
    color: "black",
    fontWeight: "bold",
    fontStyle: "italic",
  },
}));

type OrganizationFieldProps = {
  organizationId?: string;
  label?: string;
  tooltipEnabled?: boolean;
  tooltipHeader?: string;
  tooltipBody?: string;
} & Omit<TextFieldProps, "variant">;

const OrganizationField = ({
  organizationId,
  label,
  tooltipEnabled,
  tooltipHeader,
  tooltipBody,
  ...rest
}: OrganizationFieldProps) => {
  const styles = useStyles(useTheme());
  const { organizationService } = useGlobalContext();
  const fetchedOrganization = useQuery<ResponseOfOrganizationDetails>(
    ["organizations", organizationId],
    () => organizationService.getOrganization(organizationId!),
    {
      enabled: !!organizationId,
    }
  );

  return (
    <Tooltip
      arrow
      title={
        tooltipEnabled && (
          <Box>
            {tooltipHeader && (
              <Typography fontWeight="bold">{tooltipHeader}</Typography>
            )}
            {tooltipBody && <Typography>{tooltipBody}</Typography>}
          </Box>
        )
      }
    >
      <TextField
        {...rest}
        variant="standard"
        fullWidth
        label={label}
        InputLabelProps={{
          required: true,
          sx: styles.organizationLabel,
        }}
        value={fetchedOrganization?.data?.data?.name ?? ""}
      />
    </Tooltip>
  );
};

export default OrganizationField;
